import React from 'react';

import Image from 'react-bootstrap/Image';

class Loading extends React.Component {
    render() {
	return (
	    <div className="d-flex justify-content-center">
		<Image fluid align="center" src="loading.gif" />
	    </div>
	);
    }
}

export default Loading;
